import React, { useContext } from "react";
import GoalContext from "../../store/goal-context";
import classes from "./CloseButton.module.scss";
import sustainableLogo from '../../assets/dundee-sustainable-logo.svg';

const CloseButton = () => {
    const goalContext = useContext(GoalContext);
    
    const closeGoalHandler = () => {
        const anchor = document.querySelector('#goal-header');
        anchor.scrollIntoView({
            behavior: 'auto'
        });
        document.body.classList.remove('goal-open');
        goalContext.setActiveGoal(null);
        goalContext.setActiveLocation(null);
        goalContext.setActiveMarker(null);
    }

    return (
        <button className={`${classes['close-goal']} ${goalContext.activeGoal !== null ? classes.active : ""}`} onClick={closeGoalHandler}>
            <div className={classes.logo}><img src={sustainableLogo} alt="Sustainable Dundee Logo"/></div>
            <div className={classes.text}>View all goals</div>
        </button>
    )
}

export default CloseButton;